"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconHeatPumps = function IconHeatPumps(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M28.5 5.658 19 14.163V17h2v-1.943l7.5-6.714 7.5 6.715V29h2V14.163zM33 16h-4v6h4zm-1 1v4h-2v-4zM17 31v1H4v-1h7V15.256l8.68-8.69 2.027 2.027-1.414 1.414-.614-.613L13 16.084V31zm26 1v-1H30v1zm-12.576 6.562a2.36 2.36 0 0 1 3.334.002 2.36 2.36 0 0 1 .12 3.203l-.116.125.005.005-.74.74-1.414-1.414.734-.734-.005-.005a.36.36 0 0 0 .002-.506.36.36 0 0 0-.443-.051l-.064.05-2.321 2.331a2.36 2.36 0 0 1-3.334-.002 2.36 2.36 0 0 1-.12-3.203l.12-.129 2.32-2.33.81.807-.82-.817a.36.36 0 0 0 .002-.506.36.36 0 0 0-.443-.051l-.065.051-6.203 6.192a2.25 2.25 0 0 1-2.347.457c-.751-.29-1.287-.958-1.415-1.811L18 40.78V24h.999l-.997-.069a4.23 4.23 0 0 1 3.72-3.909l.21-.02h.137a4.23 4.23 0 0 1 3.909 3.72l.02.21L25 24H26v7h-2v-6.962a2.23 2.23 0 0 0-1.904-2.023l-.096-.01-.096.01a2.23 2.23 0 0 0-1.889 1.89l-.015.142-.003 16.65a.25.25 0 0 0 .159.214c.071.027.15.02.203-.006l.034-.023 6.36-6.35.01.01a2.36 2.36 0 0 1 3.145.172 2.36 2.36 0 0 1 .12 3.203l-.12.129.01.01-2.32 2.33a.36.36 0 0 0-.002.506.36.36 0 0 0 .441.053l.064-.05 2.32-2.33.74.735z",
    clipRule: "evenodd"
  })));
};

export { IconHeatPumps, IconHeatPumps as default };
